import { layers } from '@atlassian/jira-common-styles/src/main.tsx';

export const DRAWER_Z_INDEX = layers.navigation - 1;
